<div class="dialog-content">
    <div class="d-flex flex-column align-items-center justify-content-center mb-4">
        <img src="./assets/icons/warning_dialog.svg" alt="warning">
        <p class="title-size-2 color-black mb-0">¡Atención!</p>
    </div>
    <div class="mb-4">
        <p class="text-size-2 mb-0 text-center">Hemos detectado que posiblemente tenga un pago inconcluso por un total
            de ${{transaction.amount | numberNotRound}}</p>
        <p class="text-size-low mb-0 text-center color-omicron">*Si ya realizó el pago se recomienda <span
                class="font-omicron-bold">no cancelar el pedido</span></p>
        <p class="text-size-low mb-0 text-center color-omicron">*Revise su estado de cuenta antes de cancelar</p>
        <p class="text-size-low mb-0 text-center color-omicron">*Contacte a su asesor para más información</p>
    </div>
    <div class="d-flex actions-content ">
        <div class="col-md-6 col-12 p-1 justify-content-center d-flex">
            <button  class=" font-size-button white-button width-100" mat-stroked-button color="primary"
                (click)="cancel()">
                Cancelar operación
            </button>
        </div>
        <div class="col-md-6 col-12 p-1 justify-content-center d-flex">
            <button name="btn-continue-direction blue-button" mat-raised-button
                class="blue-button width-100" color="primary" (click)="continue()">
                Continuar operación
            </button>
        </div>

    </div>
</div>